// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Router from "next/router";
import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as HeaderVm$PorterinFeature from "../vm/HeaderVm.mjs";
import * as MobileLoginCmp$PorterinFeature from "./MobileLoginCmp.mjs";
import * as LinkTrackOrdersCmp$PorterinFeature from "./LinkTrackOrdersCmp.mjs";

function MobileMenuAuthSection(Props) {
  var isBookingFlowEnabled = Props.isBookingFlowEnabled;
  var is_authenticated = Props.is_authenticated;
  var order_history = Props.order_history;
  var router = Router.useRouter();
  var match = isBookingFlowEnabled || router.pathname === Config$PorterinUtils.internal_path;
  return React.createElement(React.Fragment, undefined, is_authenticated ? React.createElement(React.Fragment, undefined, React.createElement(MobileLoginCmp$PorterinFeature.make, {}), React.createElement(LinkTrackOrdersCmp$PorterinFeature.make, {
                        count_of_ongoing_order: HeaderVm$PorterinFeature.countOfLiveOrder(order_history),
                        order_crn: HeaderVm$PorterinFeature.orderCrn(order_history, 0),
                        is_courier_order: HeaderVm$PorterinFeature.isCourierOrder(order_history, 0)
                      })) : (
                match ? React.createElement(MobileLoginCmp$PorterinFeature.make, {}) : null
              ));
}

var make = MobileMenuAuthSection;

export {
  make ,
}
/* react Not a pure module */
